import { FC } from 'react'
import { ContentContainer } from '../../../../components/custom_components/ContentContainer'
import { LoadingAndErrors } from '../../../../components/custom_components/LoadingAndErrors'
import { CurrencyFromContractProvider } from '../../../../context/currency-context'
import { useMeetingEmployeePreparation } from '../../../../graphql/meeting/hooks/useMeetingEmployeePreparation'
import { MeetingType } from '../../../../types'
import EmployeePrepareOtherMeeting from '../../../otherMeetings/EmployeePrepareOtherMeeting'
import { MeetingViewProps } from '../shared/appraisal-types'
import EmployeePrepareMeetingView from './EmployeePrepareMeetingView'
import { useCollapse } from '../../../../routes/collapse-context'
import { useAuth } from '../../../../context/auth-context'

const EmployeePrepareViewContainer: FC<MeetingViewProps> = ({ match }) => {
  const meetingId = match.params.id
  const collapsed = useCollapse()
  const { user } = useAuth()

  const { data, error, loading } = useMeetingEmployeePreparation(meetingId)

  if (
    loading ||
    error ||
    !data ||
    !data.meetingEmployeePreparation ||
    !data.meetingEmployeePreparation.employee ||
    data.meetingEmployeePreparation.employee.id !== user.employeeId ||
    data.meetingEmployeePreparation.employeePrepared
  ) {
    return (
      <ContentContainer collapsed={collapsed}>
        <LoadingAndErrors
          isLoading={loading}
          hasNoData={!data || !data.meetingEmployeePreparation || !data.meetingEmployeePreparation.employee}
          error={error}
          isPermissionDenied={
            !error &&
            !!data &&
            !!data.meetingEmployeePreparation &&
            !!data.meetingEmployeePreparation.employee &&
            (data.meetingEmployeePreparation.employee.id !== user.employeeId || data.meetingEmployeePreparation.employeePrepared)
          }
        />
      </ContentContainer>
    )
  }

  const meetingType = data.meetingEmployeePreparation.type

  return (
    <CurrencyFromContractProvider employeeId={data.meetingEmployeePreparation.employee.id}>
      {meetingType === MeetingType.Appraisal || meetingType === MeetingType.AppraisalUpdate ? (
        <EmployeePrepareMeetingView meeting={data.meetingEmployeePreparation} />
      ) : (
        <EmployeePrepareOtherMeeting meeting={data.meetingEmployeePreparation} />
      )}
    </CurrencyFromContractProvider>
  )
}

export default EmployeePrepareViewContainer
